import { faqConstants } from '../constants';

export function faqs(state = {}, action) {
  switch (action.type) {
    case faqConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case faqConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case faqConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddFaq(state = {}, action) {
  switch (action.type) {
    case faqConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case faqConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case faqConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetFaq(state = {}, action) {
  switch (action.type) {
    case faqConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case faqConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case faqConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateFaq(state = {}, action) {
  switch (action.type) {
    case faqConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case faqConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case faqConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}